import React from "react";

import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import { Modal } from "components";
import { ButtonPrimary } from "components/Atoms/Button";
import { useMutation } from "@tanstack/react-query";

interface Props {
  optionsPanel: server.dto.OptionsPanelDataV2
  listUrl: string
  userId: number;
}

const UserDetailOptionsPanel = (props: Props) => {
  const [displayResetPassword, setDisplayResetPassword] = React.useState(false);

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanel}
      links={[
        { text: "List view", visible: true, href: props.listUrl },
        { text: "Reset password", visible: true, onClick: () => { setDisplayResetPassword(true); } },

      ]}
    />
    {displayResetPassword &&
      <ResetConfirmationModal userId={props.userId} onClose={() => { setDisplayResetPassword(false); }} />
    }
  </>

};

interface ConfirmationProps {
  onClose: () => void
  userId: number
}

const ResetConfirmationModal = (props: ConfirmationProps) => {
  const resetMutation = useMutation(window.CoreApi.User.ResetPassword)
  const onReset = async () => {
    resetMutation.mutateAsync(props.userId);
  }

  const hasServerError = resetMutation.data?.data.hasErrors
  const wasSuccessful = resetMutation.data?.data.data != null;
  const hasError = resetMutation.isError;
  return <Modal
    isOpen
    handleClose={props.onClose}
    title={RESX.Account.ResetPassword}
  >
    {hasError && <div className="ui red">
      {RESX.GeneralLabels.SomethingUnexpectedHappened}
    </div>}

    {hasServerError && <div className="ui red">
      {resetMutation.data?.data.errors.join("\n")}
    </div>}

    {wasSuccessful && <div dangerouslySetInnerHTML={{ __html: resetMutation.data.data.data }}>
    </div>}

    {!wasSuccessful && <>
      <div>{RESX.GeneralWarnings.AreYouSure}</div>

      <div className="flex">
        <div className="grow1"></div>
        <div>
          <ButtonPrimary label={RESX.Account.ResetPassword} disabled={resetMutation.isLoading} loading={resetMutation.isLoading} onClick={onReset} />
        </div>
      </div>
    </>}
  </Modal>
}

export default UserDetailOptionsPanel;